"use client";

import Image from "next/image";
import { useTheme } from "next-themes";
import React from "react";

type Props = {
  className?: string;
};

function LogoText({ className }: Props) {
  const { resolvedTheme } = useTheme();
  const src =
    resolvedTheme === "dark"
      ? "/images/logo/logotext-light.svg"
      : "/images/logo/logotext.svg";

  return (
    <Image
      src={src}
      alt="Arya Crypto"
      width={412}
      height={135}
      className={`w-auto ${className ?? ""}`}
      priority
    />
  );
}

export default LogoText;
